import Header from './Header.vue';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/header/index.ts